export const FILL_DETAILS = 'FILL_DETAILS';
